import { ConvertedContentHubArticle } from '@propertypal/shared/src/types/strapi/overrides';
import React from 'react';
import PageNumbers from '../search/PageNumbers';
import ContentHubArticleBox from './ContentHubArticleBox';
import { Grid } from './ContentHubArticleGrid.style';

export interface ContentHubArticleGridResultsProps {
  url: string;
  articles: ConvertedContentHubArticle[];
  page: number;
  totalPages: number;
}

const ContentHubArticleGridResults: React.FunctionComponent<ContentHubArticleGridResultsProps> = (props) => {
  return (
    <>
      <Grid>
        {props.articles.map((article) => (
          <ContentHubArticleBox key={article.id} article={article} />
        ))}
      </Grid>

      {props.totalPages > 1 && (
        <PageNumbers currentPage={props.page} totalPages={props.totalPages} currentUrl={props.url} useQueryString />
      )}
    </>
  );
};

export default ContentHubArticleGridResults;
